import { Pipe, PipeTransform,NgModule } from '@angular/core';
@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();
    return items
      .map(item => {
        if (item.label.toLowerCase().includes(searchText)) {
          return item;
        }
        if (item.children) {
          const filteredChildren = item.children.filter(child =>
            child.label.toLowerCase().includes(searchText)
          );
          if (filteredChildren.length) {
            return { ...item, children: filteredChildren };
          }
        }
        return null;
      })
      .filter(item => item !== null);
   }
}

